import { render } from "./VerifyPage.vue?vue&type=template&id=a147eaf6"
import script from "./VerifyPage.vue?vue&type=script&lang=js"
export * from "./VerifyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__